import { ErrorPage } from '@/components/errorPage/errorPage';
import { history } from '@/components/root';
import { ROUTE_WORKFLOW_DASHBOARD } from '@/constant/routes';

export const PageUnauthorized = () => {
  const goToHome = () => history.push(ROUTE_WORKFLOW_DASHBOARD);

  return (
    <ErrorPage
      description="You don't have access to this page"
      onHomeClick={goToHome}
    />
  );
};
